export default __webpack_public_path__ + "static/media/ELIKSIR-00484.0b6782c2.JPG";